let routes = [
  // {
  //   name: "WarehouseDetail",
  //   path: "/negozi-e-volantini/negozi/:slug",
  //   meta: {
  //     breadCrumb: "Negozi e volantini",
  //     site: "site"
  //   },
  //   component: () => import("@/views/store/WarehouseDetail.vue")
  // },
  {
    path: "/volantini",
    meta: {
      site: "site"
    },
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "",
        name: "Leaflets",
        meta: {
          site: "site",
          slug: "volantini"
          // pageName: "leaflets"
        },
        component: () => import("@/views/catalog/Leaflets.vue")
      },
      {
        path: "/volantini/:leafletId",
        name: "Leaflet",
        meta: {
          site: "site"
          // slug: "leaflet"
        },
        props: route => ({
          leafletId: route.params.leafletId
        }),
        component: () => import("@/views/catalog/Leaflet.vue")
      },
      {
        path: "/volantini/:leafletId/lista",
        name: "LeafletList",
        meta: {
          site: "site"
          // ,
          // pageName: "leaflet-list"
        },
        props: route => ({
          leafletId: route.params.leafletId
        }),
        component: () => import("@/views/catalog/LeafletList.vue")
      }
    ]
  },
  {
    path: "/leaflet/:leafletId/:page",
    name: "LeafletProduct",
    meta: {
      site: "site"
    },
    props: route => ({
      productId: route.query.product_id,
      leafletId: route.params.leafletId,
      page: route.params.page
    }),
    component: () => import("@/views/catalog/LeafletProduct.vue")
  },
  {
    //gestione gerarchica del catalogo per poter gestire il reset filters all'ingresso.
    path: "/catalog",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    beforeEnter(to, from, next) {
      global.EventBus.$emit("resetFilters");
      next();
    },
    children: [
      {
        path: "/search",
        name: "Search",
        component: () => import("@/views/catalog/Search.vue"),
        meta: {
          slug: "search"
        },
        props: route => ({
          query: route.params,
          parent_category_id: route.params.parent_category_id,
          filter: route.params.filter,
          mode: "search"
        })
      },
      {
        path: "/fast-search",
        name: "FastSearch",
        meta: {
          slug: "fast-search"
        },
        component: () => import("@/views/catalog/FastSearch.vue"),
        props: route => ({
          query: route.query.q
        })
      },
      {
        path: "/category/*",
        name: "Category",
        component: () => import("@/views/catalog/Category.vue"),
        meta: {
          keepAlive: true
        },
        props: route => ({
          slug: route.params.pathMatch,
          categoryId: route.query.categoryId
        })
      },
      {
        path: "/product/:slug",
        name: "Product",
        component: () => import("@/views/catalog/Product.vue"),
        props: route => ({
          slug: route.params.pathMatch
        })
      }
    ]
  }
];

export default routes;
